<script lang="ts" setup>
import { PrimaryButton } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';
import TextAndImage from '@/page/infrastructure/components/TextAndImage.vue';

const { getBaseUrl, getIaFQuoteUrl } = useUrlHelper();
</script>

<template>
  <TextAndImage div-class="pb-0" content-direction="right">
    <template #text>
      <div class="flex flex-col justify-center space-y-6">
        <span class="text-2xl lg:text-3xl font-bold text-slate-700">¿Qué es un plan de salud calificado?</span>
        <p>
          Para que los californianos cumplan con el mandato, necesitarán estar inscritos en un plan de salud
          calificado que cumpla con los requisitos del gobierno para la cobertura esencial mínima. El
          requisito principal de cobertura es que el seguro debe cubrir los 10 beneficios esenciales mínimos, como los
          servicios preventivos, la
          <a :href="getBaseUrl('/covered-california/prescription-drug-benefits')" class="text-blue-500 hover:underline">cobertura de medicamentos recetados</a>,
          y la atención de maternidad y del recién nacido. Un plan médico aún puede ser un plan de salud calificado sin
          los beneficios esenciales mínimos si el plan es un
          <a :href="getBaseUrl('/covered-california/grandfathered-plans')" class="text-blue-500 hover:underline">plan con derechos adquiridos</a>,
          que es un plan médico que estaba vigente antes del 23 de marzo de 2010, cuando se aprobó el mandato, y que no
          ha sufrido cambios importantes. Los planes de salud calificados pueden adquirirse a través de Covered
          California,
          <a :href="getBaseUrl('/covered-california/health-insurance-companies/medi-cal')" class="text-blue-500 hover:underline">Medi-Cal</a>,
          Medicare, seguro grupal, un plan a través del ejército, o fuera del mercado directamente a través de la
          aseguradora.
        </p>
      </div>
    </template>
    <template #image>
      <div class="flex flex-1 justify-center pb-16 lg:pb-0">
        <img class="flex rounded" src="https://s3-us-west-1.amazonaws.com/hp-prod-wp-data/content/uploads/doctor-prescribe.png">
      </div>
    </template>
  </TextAndImage>
  <div class="max-w-7xl mx-auto md:px-6 py-16">
    <div class="flex flex-row justify-center">
      <PrimaryButton label="Obtén tu cotización gratis" size="lg" :href="getIaFQuoteUrl()" />
    </div>
  </div>
</template>
